import React from "react"
import {ThemeProvider} from "styled-components"
import {gutter} from "../utils/vars";

function ThemeContainer({children}) {
  const gridSpacingConfig = {
    space: [0, gutter, gutter * 1.5, gutter * 2]
  }

  const themeValues = {
    overlayColor: "white",
    headerBgColor: "black",
    headerTextColor: "white"
  }

  return (
    <ThemeProvider theme={{...themeValues, ...gridSpacingConfig}}>
      {children}
    </ThemeProvider>
  )
}

export default ThemeContainer
